import {
	AssociateData,
	FinalizeHubspotDealResponse,
} from '@/helpers/hubspot/types';
import { createNoteWithAttachmentAndAddToDeal } from './createNoteWithAttachmentAndAddToDeal';

import { Dispatch } from 'react';
import { encryptId } from '@/helpers/encrypt-decrypt';
import { getContact } from './getContact';
import { getHubspotDeal } from './getHubspotDeal';
import { getOrigin } from '@/helpers/getOrigin';
import logError from '@/helpers/logError';
import { ReplaceVirtuallyFormActionMap } from '../reducer';
import { ReplaceVirtuallyFormState } from '../constants';

export async function finalizeHubspotDeal(
	state: ReplaceVirtuallyFormState,
	dispatch: Dispatch<ReplaceVirtuallyFormActionMap>,
): Promise<FinalizeHubspotDealResponse> {
	try {
		// Grab the deal id
		const hubspotDealId = await getHubspotDeal(state, dispatch);
		// If we have pictures and a deal id, create a note with the file and add it to the deal
		if (state.pictures.length > 0 && hubspotDealId) {
			await createNoteWithAttachmentAndAddToDeal(
				state,
				dispatch,
				hubspotDealId,
			);
		}
		// Associate the contact with the deal
		const contact = await getContact(state, dispatch);
		if (contact && hubspotDealId) {
			const body: AssociateData = {
				fromObjectType: 'contact',
				fromObjectId: contact,
				toObjectType: 'deal',
				toObjectId: hubspotDealId,
				associationCategory: 'HUBSPOT_DEFINED',
				associationTypeId: 4,
			};

			await fetch(`/api/hubspot/associate`, {
				method: 'PUT',
				body: JSON.stringify(body),
			});
		}

		const encryptedId = encryptId(hubspotDealId || '');

		const uniqueUrl = new URL(
			`/replace/download/hs-${encryptedId}`,
			getOrigin(),
		).toString();

		// @TODO add back when ready HVAC3-2242
		// const leadPaymentUrl = `${constants.LEAD_PAYMENT_URL}${encryptedId}`;
		const leadPaymentUrl = '';

		return {
			success: true,
			dealInfo: { dealId: hubspotDealId || '', uniqueUrl, leadPaymentUrl },
		};
	} catch (error) {
		logError(
			error instanceof Error
				? error
				: new Error('An error occurred finalizing the deal'),
		);
		return { success: false };
	}
}
